import { createFileRoute } from '@tanstack/react-router';
import MyOffers from '../../components/client/MyOffers';
import ClientPortal from '../../components/portals/ClientPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockUser } from '../../data/mockData';

export const Route = createFileRoute('/client/offers')({
  component: ClientOffersRoute,
});

function ClientOffersRoute() {
  const { user, isManager } = useAuth();
  const content = <MyOffers user={user && !isManager ? user : mockUser} />;
  return <ClientPortal>{content}</ClientPortal>;
}
